<template>
	<div class="navbar navbar-expand-lg navbar-light fixed-top justify-content-between" id="mainNavbar">
		<div class="d-flex f-1">
			<span class="pointer mr-2 sidebar-toggle" @click="toggleSideMenu" v-if="isAuthenticated">
				<i class="fa fa-bars"></i>
			</span>
		</div>
		<div class="d-flex justify-content-center f-1">
			<router-link class="navbar-brand" router to="/">{{$t("appTitle")}}</router-link>
		</div>

		<div class="d-flex justify-content-end f-1 z-i">
			<div>
				<div class="dropdown" v-if="isAuthenticated">
					<button
						class="btn btn-link dropdown-toggle"
						style="text-decoration: none;"
						type="button"
						id="dropdownMenuButton"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<span class="d-none d-sm-none d-md-inline-block text-uppercase">{{userName}}</span>
						<span class="fa fa-ellipsis-v d-md-none"></span>
						<span class="badge badge-pill badge-warning tasks-badge" v-if="userTasks">{{userTasks}}</span>
						<span class="badge badge-pill badge-info coordination-badge" v-if="userCoordinations">{{userCoordinations}}</span>
					</button>
					<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
						<div class="dropdown-item p-0" v-if="isAuthenticated">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/account">{{$t('account.title')}}</router-link>
						</div>
						<div class="dropdown-item pointer p-0" v-if="isAuthenticated">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/tasks">{{$t('sideMenu.tasks')}}
								<span class="float-right">
									<span v-if="userTasks"
										class="badge badge-pill badge-success ml-1"
										data-toggle="tooltip"
										:title="userTasks > 1 ? $t('tasks.newTasks') : $t('tasks.newTask')">
										{{userTasks}}
									</span>
									<span v-if="userStartedTasks"
										class="badge badge-pill badge-info ml-1"
										data-toggle="tooltip"
										:title="$tc('tasks.notCompleted', userStartedTasks)">
										{{userStartedTasks}}
									</span>
									<span v-if="userOverdueTasks"
										class="badge badge-pill badge-danger ml-1"
										data-toggle="tooltip"
										:title="$tc('tasks.overdueTasks', userOverdueTasks)">
										{{userOverdueTasks}}
									</span>
								</span>
							</router-link>
						</div>
						<div class="dropdown-item pointer p-0" v-if="isAuthenticated">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/coordinations">{{$t('sideMenu.coordinations')}}
								<span class="float-right">
									<span v-if="userCoordinations"
										class="badge badge-pill badge-success ml-1"
										data-toggle="tooltip"
										:title="$tc('coordinations.uncompleted', userCoordinations)">
										{{userCoordinations}}
									</span>
									<span v-if="userOverdueCoordinations"
										class="badge badge-pill badge-danger ml-1"
										data-toggle="tooltip"
										:title="$tc('coordinations.overdueCoordinations', userOverdueCoordinations)">
										{{userOverdueCoordinations}}
									</span>
								</span>
							</router-link>
						</div>
						<div class="dropdown-item pointer p-0" v-if="isAuthenticated">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/logs">{{$t('account.logs')}}</router-link>
						</div>
						<div class="dropdown-item pointer p-0" v-if="isAuthenticated">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/dynamicLayout">{{$t('dynamicLayout.homePageLayout')}}</router-link>
						</div>
						<!--<div class="dropdown-item pointer p-0">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/help">{{$t('help.menuTitle')}}</router-link>
						</div>-->
                        <div class="dropdown-item pointer p-0" v-if="isAuthenticated && claims.qesLocalServer.read">
							<router-link class="btn btn-link w-100 m-0 text-left" to="/localServer">{{$t('localServer.title')}}</router-link>
						</div>
						<div class="dropdown-item pointer p-0" @click="logout">
							<button class="btn btn-link w-100 m-0 text-left">{{$t('logout')}}</button>
						</div>
					</div>
				</div>
				<router-link class="btn btn-secondary" to="/login" v-if="!isAuthenticated">{{$t('login')}}</router-link>
			</div>
			<div>
				<img src="../../assets/bg_flag.png" alt="BG" class="pointer" v-if="currentCulture == 'en'" @click="setCulture({lang: 'bg', service: $i18n})" />
				<img src="../../assets/UK_flag.png" alt="ENG" class="pointer" v-if="currentCulture == 'bg'" @click="setCulture({lang: 'en', service: $i18n})" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	data() {
		return {
			currentLanguage: 'bg'
		};
	},
	computed: mapGetters(['currentCulture', 'isAuthenticated', 'userName',
        'userTasks', 'userStartedTasks', 'userOverdueTasks', 'userCoordinations',
        'userOverdueCoordinations', 'claims']),
	methods: {
		toggleSideMenu() {
			this.$store.dispatch('toggleSideMenu');
		},
		async logout() {
            try {
				await this.$store.dispatch('logout');
                this.$store.dispatch('setUserTasks', { tasks: null, startedTasks: null, overdueTasks: null, coordinations: null, overdueCoordinations: null });
				this.$store.dispatch('clearUserPolicies');

				this.$router.push('/login');
            } catch (error) {
                this.$vs.notify({
                    title: this.$t('logout'),
                    text: '',
                    color: 'danger'
                });

				console.log(error);
            }
		},
		...mapActions(['setCulture'])
	}
};
</script>

<style lang="scss" scoped>
.navbar {
	background-color: #009688;
	color: white !important;
	// background-image: linear-gradient(#0adeca, #009688, #0adeca);
	height: 3.5rem;

	a,
	button {
		color: white;
	}

	.dropdown-menu {
		a,
		button {
			color: #009688;
		}
	}
}

@media (max-width: 764px) {
	.navbar {
		height: 3rem;
	}
}

.sidebar-toggle {
	font-size: 1.5em;
}

.f-1 {
	flex: 1;
}

.dropdown-menu.dropdown-menu-right.show {
	left: auto;
	right: 0;
	z-index: 9999 !important;
}

.tasks-badge {
	position: absolute;
	top: 25px;
	right: 15px;
}

.coordination-badge {
	position: absolute;
	top: 25px;
	right: 45px;
}

.tasks-badge-menu {
	position: absolute;
	right: 15px;
}
</style>
